module.exports = __webpack_public_path__ + "static/media/img-pop-up-my-montepio-zippy-worten.18e1508e.svg";